import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

export interface AlertPanelViewModel {
  alertType: string;
  subscribedCount: number;
  totalCount: number;
  disabled: boolean;
}

@Component({
  selector: 'app-alert-panel',
  templateUrl: './alert-panel.component.html',
  styleUrls: ['./alert-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertPanelComponent {
  @Input() viewModel!: AlertPanelViewModel;
  @Output() panelClick = new EventEmitter<any>();

  onClick(): void {
    if (!this.viewModel.disabled) {
      this.panelClick.emit(this.viewModel.alertType);
    }
  }
}
